
import moment from 'moment-timezone';

// calculate timeline interval based on session start time
export function calcInterval({ sessionStartTime }) {
  const from = moment(sessionStartTime);
  const to = moment(from).add(1, 'hours');
  const midTime = (moment(to).valueOf() + moment(from).valueOf()) / 2;
  let end = moment(midTime).add(12, 'hours');
  if (end.isAfter(moment())) {
    end = moment();
  }
  const start = moment(end).subtract(24, 'hours');
  const timelineInterval = `${start.toISOString()}/${end.toISOString()}`;
  return timelineInterval;
}

export function updateRequest(request) {
  const { meta } = request;
  // update interval based on session start time
  // this is to refresh timelines saved while a session was active
  if (meta && meta.sessionStartTime) {
    request.timelineInterval = calcInterval(meta);
  }
}
